import React from "react";
import styled from '@emotion/styled';
import { OMGTheme } from '@ordermygear/theme';
import { Sale, Dealer } from '../../../../backend/shared/types';

const HeaderContainer = styled.header`
  width: 100%;
  height: 100%;
  margin: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 34px;
  border-bottom: 1px solid ${OMGTheme.colors.grayLightBorder};
`;

type HeaderProps = {
  sale: Sale;
  dealer: Dealer;
}

const Header = (props: HeaderProps) => {
  const {
    sale,
    dealer
  } = props;
  let url, sale_logo;
  if (sale) {
    url = sale.url;
    sale_logo = sale.primary_logo && sale.primary_logo.asset_url ? sale.primary_logo.asset_url : "";
  } else {
    url = dealer.website;
    sale_logo = dealer.dealer_logo;
  }
  return (
    <HeaderContainer>
      <a href={url}>
        <img src={sale_logo} />
      </a>
    </HeaderContainer>
  );
};

export default Header;